import { Component, Injector } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { Art57Section } from '../../ui/Art57Section/Art57Section';

@Component({
  selector: 'app-bulk-update-change-repeater-type',
  templateUrl: './bulk-update-change-repeater-type.component.html',
  styleUrl: './bulk-update-change-repeater-type.component.scss'
})
export class BulkUpdateChangeRepeaterTypeComponent extends FieldArrayType {
    constructor (private injector: Injector){
      super();
    }
  // Use a stable trackBy to reduce DOM churn and preserve control state between changes.
  trackByIndex = (index: number) => index;

  override add(){
    super.add();
 }
}